module.exports = __webpack_public_path__ + "img/souvenier-2.1f63fdac.png";